import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Kategori.css'

const Kategori = ({ ad, resim }) => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = () => {
    const routeMap = {
      // İçecekler kategorileri
      'Sıcak Kahveler': '/sicak-kahveler',
      'Soğuk Kahveler': '/soguk-kahveler',
      'Sıcak İçecekler': '/sicak-icecekler',
      'Soğuk İçecekler': '/soguk-icecekler',
      'Kokteyller': '/kokteyller',
      'Türk Kahveleri': '/turk-kahveleri',
      'Meşrubatlar': '/mesrubatlar',
      // Yemekler kategorileri
      'Dostluk Pekiştirenler': '/dostluk-pekistirenler',
      'Gözlemeler': '/gozlemeler',
      'Hamburgerler': '/hamburgerler',
      'Makarnalar': '/makarnalar',
      'Tostlar': '/tostlar',
      'Wraplar': '/wraplar'
    };
    
    const route = routeMap[ad];
    if (route) {
      navigate(route);
    }
  };

  return (
    isPhone ? (
    <div className="kategori-kart" onClick={handleClick} style={{ cursor: 'pointer' }}>
        <p className="kategori-ad">{ad}</p>
        <img src={resim} alt={ad} className="kategori-resim" />
    </div>
  ) : (
    <div className="kategori-kart-computer" onClick={handleClick} style={{ cursor: 'pointer' }}>
        <p className="kategori-ad-computer">{ad}</p>
        <img src={resim} alt={ad} className="kategori-resim" />
    </div>
  )
  )
}

export default Kategori
